import { ADD_SUB_TASK, ADD_SUB_TASK_FAILED, ADD_SUB_TASK_SUCCESS, ADD_TASK, ADD_TASK_CATEGORY, ADD_TASK_CATEGORY_FAILED, ADD_TASK_CATEGORY_SUCCESS, ADD_TASK_FAILED, ADD_TASK_FILES, ADD_TASK_FILES_FAILED, ADD_TASK_FILES_SUCCESS, ADD_TASK_LABEL, ADD_TASK_LABEL_FAILED, ADD_TASK_LABEL_SUCCESS, ADD_TASK_STATUS, ADD_TASK_STATUS_FAILED, ADD_TASK_STATUS_SUCCESS, ADD_TASK_SUCCESS, CLEAR_ADD_TASK_STATUS, DELETE_SUB_TASK, DELETE_SUB_TASK_FAILED, DELETE_SUB_TASK_SUCCESS, DELETE_TASK, DELETE_TASK_CATEGORY, DELETE_TASK_CATEGORY_FAILED, DELETE_TASK_CATEGORY_SUCCESS, DELETE_TASK_FAILED, DELETE_TASK_FILES, DELETE_TASK_FILES_FAILED, DELETE_TASK_FILES_SUCCESS, DELETE_TASK_LABEL, DELETE_TASK_LABEL_FAILED, DELETE_TASK_LABEL_SUCCESS, DELETE_TASK_STATUS, DELETE_TASK_STATUS_SUCCESS, DELETE_TASK_SUCCESS, FILTERED_TASK, FILTERED_TASK_FAILED, FILTERED_TASK_SUCCESS, SUB_TASK, SUB_TASK_FAILED, SUB_TASK_SUCCESS, TASK, TASK_CATEGORY, TASK_CATEGORY_FAILED, TASK_CATEGORY_SUCCESS, TASK_FAILED, TASK_FILES, TASK_FILES_FAILED, TASK_FILES_SUCCESS, TASK_LABEL, TASK_LABEL_FAILED, TASK_LABEL_SUCCESS, TASK_STATUS, TASK_STATUS_FAILED, TASK_STATUS_SUCCESS, TASK_SUCCESS, UPDATE_SUB_TASK, UPDATE_SUB_TASK_FAILED, UPDATE_SUB_TASK_SUCCESS, UPDATE_TASK, UPDATE_TASK_FAILED, UPDATE_TASK_FILES, UPDATE_TASK_FILES_FAILED, UPDATE_TASK_FILES_SUCCESS, UPDATE_TASK_LABEL, UPDATE_TASK_LABEL_FAILED, UPDATE_TASK_LABEL_SUCCESS, UPDATE_TASK_STATUS, UPDATE_TASK_STATUS_FAILED, UPDATE_TASK_STATUS_SUCCESS, UPDATE_TASK_SUCCESS ,RUNNING_TASK, RUNNING_TASK_SUCCESS, RUNNING_TASK_FAILED} from "./actionTypes"

let initialState = {
    task: [],
    filteredTasks: [],
    taskStatus: [],
    addTaskStatus: "",
    deleteTaskStatus: "",
    updateTaskStatus: "",
    taskCategory: [],
    addTaskCategory: "",
    deleteTaskCategory: "",
    taskLabel: [],
    addTaskLabel: "",
    updateTaskLabel: "",
    deleteTaskLabel: "",
    addTask: "",
    updateTask: "",
    deleteTask: "",
    taskFiles: [],
    addTaskFiles: "",
    updateTaskFiles: "",
    deleteTaskFiles: "",
    subTask: [],
    addSubTask: "",
    updateSubTask: "",
    deleteSubTask: "",
    loading: false,
    deleteLoading: false,
    success: false,
    error: '',
    runningTask: []
}

export const taskReducer = (state = initialState, action) => {
    switch (action.type) {

        case TASK: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case TASK_SUCCESS: return {
            ...state,
            task: action.payload,
            loading: false,
            success: true
        }
        case TASK_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case FILTERED_TASK: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case FILTERED_TASK_SUCCESS: return {
            ...state,
            filteredTasks: action.payload,
            loading: false,
            success: true
        }
        case FILTERED_TASK_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TASK: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TASK_SUCCESS: return {
            ...state,
            addTask: action.payload,
            task: [...state.task, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TASK_FAILED: return {
            ...state,
            addTask: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_TASK: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }

        case UPDATE_TASK_SUCCESS: {
            const updatedTaskId = action.payload.fulfillmentValue?.id;
            const updatedTimerTaskId = action.payload.task_id;
            const updatedTimer = action.payload;

            return {
                ...state,
                updateTask: action.payload,
                task: state.task.map((item) => {
                    if (item?.id === updatedTaskId || item?.id === updatedTimerTaskId) {
                        const updatedItem = item?.id === updatedTaskId
                            ? { ...item, ...action.payload.fulfillmentValue }
                            : { ...item };

                        if (item?.id === updatedTimerTaskId) {
                            const updatedTimerMap = updatedItem.taskTimerMap ? [...updatedItem.taskTimerMap] : [];
                            const existingIndex = updatedTimerMap.findIndex(
                                (timer) => timer.id === updatedTimer.id
                            );

                            if (existingIndex !== -1) {
                                updatedTimerMap[existingIndex] = updatedTimer;
                            } else {
                                updatedTimerMap.push(updatedTimer);
                            }

                            updatedItem.taskTimerMap = updatedTimerMap;
                        }

                        return updatedItem;
                    }

                    return item;
                }),

                filteredTasks: state.filteredTasks.map((item) => {
                    if (
                        item.task?.id === updatedTaskId ||
                        item.task?.id === updatedTimerTaskId
                    ) {
                        const updatedTask = item.task?.id === updatedTaskId
                            ? { ...item.task, ...action.payload.fulfillmentValue }
                            : { ...item.task };

                        if (item.task?.id === updatedTimerTaskId) {
                            const updatedTimerMap = updatedTask.taskTimerMap
                                ? [...updatedTask.taskTimerMap]
                                : [];
                            const existingIndex = updatedTimerMap.findIndex(
                                (timer) => timer.id === updatedTimer.id
                            );

                            if (existingIndex !== -1) {
                                updatedTimerMap[existingIndex] = updatedTimer;
                            } else {
                                updatedTimerMap.push(updatedTimer);
                            }

                            updatedTask.taskTimerMap = updatedTimerMap;
                        }

                        return {
                            ...item,
                            task: updatedTask,
                        };
                    }

                    return item;
                }),

                loading: false,
                success: true,
                error: '',
            };
        }

        case UPDATE_TASK_FAILED: return {
            ...state,
            updateTask: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case DELETE_TASK: return {
            ...state,
            deleteLoading: true,
            success: false,
            error: ''
        }
        case DELETE_TASK_SUCCESS: return {
            ...state,
            deleteTask: action.payload,
            deleteLoading: false,
            success: true
        }
        case DELETE_TASK_FAILED: return {
            ...state,
            deleteLoading: false,
            success: false,
            error: action.payload
        }

        case TASK_CATEGORY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case TASK_CATEGORY_SUCCESS: return {
            ...state,
            taskCategory: action.payload,
            loading: false,
            success: true
        }
        case TASK_CATEGORY_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TASK_CATEGORY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TASK_CATEGORY_SUCCESS: return {
            ...state,
            addTaskCategory: action.payload,
            taskCategory: [...state.taskCategory, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TASK_CATEGORY_FAILED: return {
            ...state,
            addTaskCategory: [],
            loading: false,
            success: false,
            error: action.payload
        }

        case DELETE_TASK_CATEGORY: return {
            ...state,
            deleteLoading: true,
            success: false,
            error: ''
        }
        case DELETE_TASK_CATEGORY_SUCCESS: return {
            ...state,
            deleteTaskCategory: action.payload,
            taskCategory: action.payload,
            deleteLoading: false,
            success: true
        }
        case DELETE_TASK_CATEGORY_FAILED: return {
            ...state,
            deleteLoading: false,
            success: false,
            error: action.payload
        }
        case TASK_STATUS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case TASK_STATUS_SUCCESS: return {
            ...state,
            taskStatus: action.payload,
            loading: false,
            success: true
        }
        case TASK_STATUS_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TASK_STATUS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TASK_STATUS_SUCCESS: return {
            ...state,
            addTaskStatus: action.payload,
            taskStatus: [...state.taskStatus, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TASK_STATUS_FAILED: return {
            ...state,
            addTaskStatus: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case CLEAR_ADD_TASK_STATUS:
            return {
                ...state,
                addTaskStatus: null,
            };
        case UPDATE_TASK_STATUS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_TASK_STATUS_SUCCESS: return {
            ...state,
            updateTaskStaus: action.payload,
            taskStatus: state.taskStatus.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_TASK_STATUS_FAILED: return {
            ...state,
            updateTaskStatus: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case DELETE_TASK_STATUS: return {
            ...state,
            deleteLoading: true,
            success: false,
            error: ''
        }
        case DELETE_TASK_STATUS_SUCCESS: return {
            ...state,
            deleteTaskStatus: action.payload,
            taskStatus: action.payload,
            deleteLoading: false,
            success: true
        }
        case DELETE_TASK_CATEGORY_FAILED: return {
            ...state,
            deleteLoading: false,
            success: false,
            error: action.payload
        }
        case TASK_LABEL: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case TASK_LABEL_SUCCESS: return {
            ...state,
            taskLabel: action.payload,
            loading: false,
            success: true
        }
        case TASK_LABEL_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TASK_LABEL: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TASK_LABEL_SUCCESS: return {
            ...state,
            addTaskLabel: action.payload,
            taskLabel: [...state.taskLabel, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TASK_LABEL_FAILED: return {
            ...state,
            addTaskLabel: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_TASK_LABEL: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_TASK_LABEL_SUCCESS: return {
            ...state,
            updateTaskLabel: action.payload,
            taskLabel: state.taskLabel.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_TASK_LABEL_FAILED: return {
            ...state,
            updateTaskLabel: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case DELETE_TASK_LABEL: return {
            ...state,
            deleteLoading: true,
            success: false,
            error: ''
        }
        case DELETE_TASK_LABEL_SUCCESS: return {
            ...state,
            deleteTaskLabel: action.payload,
            taskLabel: [...state.taskLabel, action.payload],
            deleteLoading: false,
            success: true
        }
        case DELETE_TASK_LABEL_FAILED: return {
            ...state,
            deleteLoading: false,
            success: false,
            error: action.payload
        }
        case TASK_FILES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case TASK_FILES_SUCCESS: return {
            ...state,
            taskFiles: action.payload,
            loading: false,
            success: true
        }
        case TASK_FILES_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TASK_FILES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TASK_FILES_SUCCESS: return {
            ...state,
            addTaskFiles: action.payload,
            taskFiles: [...state.taskFiles, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TASK_FILES_FAILED: return {
            ...state,
            addTaskFiles: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_TASK_FILES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_TASK_FILES_SUCCESS: return {
            ...state,
            updateTaskFiles: action.payload,
            taskFiles: state.taskFiles.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_TASK_FILES_FAILED: return {
            ...state,
            updateTaskFiles: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case DELETE_TASK_FILES: return {
            ...state,
            deleteLoading: true,
            success: false,
            error: ''
        }
        case DELETE_TASK_FILES_SUCCESS: return {
            ...state,
            deleteTaskFiles: action.payload,
            deleteLoading: false,
            success: true
        }
        case DELETE_TASK_FILES_FAILED: return {
            ...state,
            deleteLoading: false,
            success: false,
            error: action.payload
        }
        case SUB_TASK: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case SUB_TASK_SUCCESS: return {
            ...state,
            subTask: action.payload,
            loading: false,
            success: true
        }
        case SUB_TASK_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_SUB_TASK: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_SUB_TASK_SUCCESS: return {
            ...state,
            addSubTask: action.payload,
            subTask: [...state.subTask, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_SUB_TASK_FAILED: return {
            ...state,
            addSubTask: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_SUB_TASK: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_SUB_TASK_SUCCESS: return {
            ...state,
            updateSubTask: action.payload,
            subTask: state.subTask.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_SUB_TASK_FAILED: return {
            ...state,
            updateSubTask: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case DELETE_SUB_TASK: return {
            ...state,
            deleteLoading: true,
            success: false,
            error: ''
        }
        case DELETE_SUB_TASK_SUCCESS: return {
            ...state,
            deleteSubTask: action.payload,
            deleteLoading: false,
            success: true
        }
        case DELETE_SUB_TASK_FAILED: return {
            ...state,
            deleteLoading: false,
            success: false,
            error: action.payload
        }
        case RUNNING_TASK: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case RUNNING_TASK_SUCCESS: return {
            ...state,
            runningTask: action.payload,
            loading: false,
            success: true
        }
        case RUNNING_TASK_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        default: return state
    }
}